<div fxLayout="column" fxLayoutGap="16px" class="gt-content">

  <div fxLayout="row wrap" fxLayoutGap="16px">
    <mat-card>
      <mat-card-title>
        <mat-icon>pie_chart</mat-icon>
        {{ 'call_log.title' | translate }}
      </mat-card-title>

      <div fxLayout="column" fxFlex="400px">
        <mat-form-field>
          <mat-select [(ngModel)]="queryOption" placeholder="{{'global.number' | translate}}" (selectionChange)="retrieveCallLog()">
            <mat-option *ngFor="let queryNumber of queryNumberOptions" [value]="queryNumber">
              {{queryNumber.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select [(ngModel)]="selectedTimeInterval" placeholder="{{'call_log.period' | translate}}" (selectionChange)="retrieveCallLog()">
            <mat-option *ngFor="let timeInterval of timeIntervals" [value]="timeInterval">
              {{timeInterval.name | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card>

    <gt-card-wrapper fxFlex cardTitle="" matIcon="">
      <div fxLayout="column" fxFlex>
        <gt-statistics-chart [logEntries]="logEntries"></gt-statistics-chart>
        <div fxLayout="row" fxLayoutAlign="end center">
          <button mat-raised-button color="primary" (click)="exportToCSV()" [disabled]="logEntries === null || contacts === null">
            {{'call_log.export_excel' | translate}}
          </button>
        </div>
      </div>
    </gt-card-wrapper>
  </div>
  <gt-card-wrapper cardTitle="{{'call_log.main_log_title' | translate}}" matIcon="history">
    <gt-main-number-table [isServiceNumberLogs]="queryOption?.type === StatisticsQueryOptionTypes.SERVICENUMBER" [logEntries]="logEntries"></gt-main-number-table>
  </gt-card-wrapper>
</div>
